import React from "react";
import {useSelector} from "react-redux";
import Card from "@material-ui/core/Card/Card";
import CardHeader from "@material-ui/core/CardHeader/CardHeader";
import CardContent from "@material-ui/core/CardContent/CardContent";
import enrollmentHelp from "../../images/svg/sidebar_enrollment_help.svg";
import RightDrawer from "../../component/RightDrawer";
import Typography from "@material-ui/core/Typography/Typography";
import {NF_IUL_STRATEGY, StrategySlugEnum} from "../../../../../constants";
import {RootState} from "../../../../../reducers";

const EnrollmentHelp = () => {
    const {user} = useSelector((state: RootState) => state.auth);
    const clientPolicy = user && user.client && user.client.clientPolicies && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0]; 
    const isNfUil = clientPolicy && clientPolicy.strategy && (clientPolicy.strategy.slug === StrategySlugEnum.NfIUL && clientPolicy.strategy.id === NF_IUL_STRATEGY);

    if (isNfUil) {
        return (<></>);
    }

    return (
            <>
                <Card className="enrollmentHelpCard boxShadow w100 ">
                    <CardHeader
                            avatar={
                                <img src={enrollmentHelp as string} alt="#"/>
                            }
                            title={<React.Fragment>
                                <Typography
                                        component="span"
                                        variant="h5"
                                >
                                    Enrollment Help
                                </Typography>
                            </React.Fragment>}
                    />
                    <CardContent className="pd0">
                        <RightDrawer/>
                    </CardContent>
                </Card>
            </>
    );
};

export default EnrollmentHelp;